<template>
  <div class="bulk-order-quantity-notice">
    <p class="bulk-order-quantity-notice__text">
      <span class="bulk-order-quantity-notice__message">
        11枚以上をご希望の方はまとめてオーダーから購入いただけます。
      </span>
      <button
        type="button"
        class="bulk-order-quantity-notice__link"
        @click="onClickDetail"
      >
        詳しくはこちら
      </button>
    </p>
  </div>
</template>

<script setup>
const emit = defineEmits(['click-detail'])

const onClickDetail = () => {
  emit('click-detail')
}
</script>

<style lang="scss" scoped>
.bulk-order-quantity-notice {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  background-color: $primary-lighten;
  border-radius: 8px;

  &__text {
    margin: 0;
    color: $brown-1;
    font-size: 0;
    word-break: break-word;
  }

  &__message,
  &__link {
    @extend %caption-bold;
    color: inherit;
  }

  &__link {
    padding: 0;
    border: 0;
    font-family: inherit;
    text-decoration: underline;
    background: none;
    cursor: pointer;
  }
}
</style>
